export default __webpack_public_path__ + "static/media/woman-edit-profile.af3d3c90.svg";